<template>
  <v-card class="my-4">
    <v-toolbar color="primary" flat dark>
      <v-toolbar-title>
        Class Quiz Score
      </v-toolbar-title>
    </v-toolbar>
    <v-card-actions>
      <v-select
        v-model="selectedClass"
        label="Choose a class"
        :items="classList"
      ></v-select>
    </v-card-actions>
    <v-card-text>
      <bar-chart ref="barChart" :chart-data="overviewData" />
    </v-card-text>
  </v-card>
</template>

<script>
import Lesson from '@/modules/lesson/models/Lesson'
import Class from '@/modules/class/models/Class'
import BarChart from '@/components/charts/BarChart'

export default {
  name: 'ClassQuizScore',
  components: {
    BarChart
  },
  data() {
    return {
      selectedClass: null,
      userLessons: []
    }
  },
  async mounted() {
    this.$store.state.loading = true
    await Lesson.dispatch('fetch', this.$route.meta.type)
    await Class.dispatch('fetchForTeacher')
    this.selectedClass = this.classList[0].value
      ? this.classList[0].value
      : 'null'

    setTimeout(() => {
      this.$store.state.loading = false
    })
  },
  watch: {
    async selectedClass(val) {
      this.userLessons = await this.$axios.get(
        `api/teachers/reports?&current_class_id=${val}&type=completedStudentLessonByClass&date_start=2019-01-01&date_end=2019-01-01`
      )
      if (this.$refs.barChart) this.$refs.barChart.updateChart()
    }
  },
  computed: {
    lessons() {
      return Lesson.all()
    },
    classList() {
      const classes = Class.query()
        .orderBy('created_at', 'desc')
        .get()

      return classes.map(c => {
        return { text: c.name, value: c.id }
      })
    },
    overviewData() {
      let userLessons = this.userLessons
      let labels = []
      let prequiz = {
        label: 'Avg. Pre Quiz',
        stack: 1,
        backgroundColor: '#00ABD7',
        data: []
      }

      let postquiz = {
        label: 'Avg. Post Quiz',
        stack: 2,
        backgroundColor: '#8AFBFF',
        data: []
      }
      if (!userLessons.length) {
        labels = ['No Data']
        prequiz.data = [0]
        postquiz.data = [0]
        return { labels, datasets: [prequiz, postquiz] }
      }

      this.lessons.forEach(lesson => {
        labels.push(lesson.name)
        let totalPreQuizScore = 0
        let totalPostQuizScore = 0
        let lessonCount = 0
        for (let i = 0; i < userLessons.length; i++) {
          const userLesson = userLessons[i]
          if (userLesson.lesson_id === lesson.id) {
            totalPreQuizScore += userLesson.pre_quiz
            totalPostQuizScore += userLesson.post_quiz
            lessonCount++
          }
        }

        prequiz.data = [
          ...prequiz.data,
          lessonCount ? totalPreQuizScore / lessonCount : 0
        ]
        postquiz.data = [
          ...postquiz.data,
          lessonCount ? totalPostQuizScore / lessonCount : 0
        ]
      })

      let datasets = [prequiz, postquiz]
      let chartData = { labels, datasets }
      return chartData
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.dialog-file.v-dialog--active {
  width: 99vw;
  height: 99vh;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
